<template>
  <v-container fluid>
    <v-card :loading="loading" flat>
      <v-card-title>
        <v-btn
          v-status="'user_create'"
          class="btn-add-with-text ma-0"
          @click="newUserDialog = true"
        >
          <v-icon>mdi-plus</v-icon>
          ایجاد کاربر جدید
        </v-btn>

        <v-spacer />
        {{ $t($route.meta.title) }}
        <v-spacer />

        <v-btn
          v-status="'user_access'"
          class="btn-buy ma-0"
          @click="failedSignUps = true"
        >
          لیست ثبت نام ناموفق
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-row no-gutters>
        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-text-field
            v-model="tableProps.filters.name"
            append-icon="mdi-clipboard-account"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="نام"
            name="name"
            outlined
            @keydown.enter="onPagination()"
            @click:append="onPagination()"
            @click:clear="clearField"
          />
        </v-col>
        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-text-field
            v-model="tableProps.filters.lastName"
            append-icon="mdi-camera-account"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="نام خانوادگی"
            name="name"
            outlined
            @keydown.enter="onPagination()"
            @click:append="onPagination()"
            @click:clear="clearField"
          />
        </v-col>
        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-text-field
            v-model="tableProps.filters.username"
            append-icon="mdi-account"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="نام کاربری"
            name="name"
            outlined
            @keydown.enter="onPagination()"
            @click:append="onPagination()"
            @click:clear="clearField"
          />
        </v-col>
        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-text-field
            v-model="tableProps.filters.phone"
            append-icon="mdi-cellphone"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="تلفن همراه"
            name="name"
            outlined
            @keydown.enter="onPagination()"
            @click:append="onPagination()"
            @click:clear="clearField"
          />
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-text-field
            v-model="tableProps.search"
            append-icon="mdi-magnify"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="جستجو"
            outlined
            @keydown.enter="onPagination()"
            @click:append="onPagination()"
            @click:clear="clearField"
          />
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="3" sm="6">
          <v-select
            v-model="tableProps.filters.packId"
            :items="packs"
            :menu-props="{ offsetY: true }"
            clearable
            dense
            hide-details
            item-text="title"
            item-value="id"
            label="انتخاب پنل"
            outlined
            @change="onPagination()"
            @click:clear="clearField"
          />
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="3" sm="6">
          <v-text-field
            v-model="tableProps.filters.nid"
            append-icon="mdi-card-account-details-star"
            clearable
            dense
            hide-details
            label="کد ملی"
            outlined
            @keydown.enter="onPagination()"
            @click:append="onPagination()"
            @click:clear="onPagination()"
          />
        </v-col>

        <v-col class="pa-2 d-flex align-center" cols="12" md="3" sm="6">
          <date-picker
            v-model="tableProps.filters.last_seen"
            display-format="jYYYY-jMM-jDD"
            format="YYYY-MM-DD"
            label="آخرین ورود"
            @input="onPagination()"
          />
          <v-btn
            v-show="!!tableProps.filters.last_seen"
            icon
            small
            @click="
              () => {
                tableProps.filters.last_seen = undefined;
                onPagination();
              }
            "
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-col>

        <v-col class="pa-2" cols="12" md="3" sm="6">
          <v-select
            v-model="tableProps.filters.balance"
            :items="balanceItems"
            :menu-props="{ offsetY: true }"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="موجودی"
            outlined
            @change="onPagination()"
          />
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-select
            v-model="tableProps.length"
            :items="[10, 25, 50, 100, 200, 400]"
            :menu-props="{ offsetY: true }"
            dense
            hide-details
            label="تعداد نمایش"
            outlined
            @change="onPagination()"
          />
        </v-col>

        <v-spacer />

        <v-col class="d-flex justify-end" cols="12" md="3">
          <v-btn
            :disabled="!disableRemoveFilter"
            :loading="loading"
            class="btn-exit"
            @click="clearField(true)"
          >
            حذف فیلتر ها
            <v-icon right>mdi-close</v-icon>
          </v-btn>
        </v-col>

        <v-col class="pa-2" cols="12">
          <vue-table
            v-model="selectedRows"
            :data="userInfo"
            :headers="headers"
            :loading.sync="loading"
            :props.sync="tableProps"
            filter-on-enter
            show-select
            @change="onPagination"
          >
            <template v-slot:index="{ item }">
              {{
                item.index + 1 + (userInfo.current_page - 1) * userInfo.per_page
              }}
            </template>

            <template v-slot:id="{item}">
                  <v-chip class="rounded-lg" small>
                    {{ item.id }}
                  </v-chip>
              <v-btn class="ms-1" icon small @click="copyText(item.id)">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </template>

            <template v-slot:username="{item}">
              <v-chip :color="officialTypeColor(item.official_type)"
               class="py-1 px-2 font-weight-bold elevation-2"   
              style="border: 1px solid rgba(255, 255, 255, 0.3);"
              >
              {{ item.username }}
              </v-chip>
            </template>

            <template v-slot:phone="{ item }">
              <user-phone-buttons :data="item" />
            </template>

            <template v-slot:pack="{ item }">
              <span v-if="!!item && !!item.pack">
                {{ item.pack.title }}
              </span>
              <span v-else>-</span>
            </template>

            <template v-slot:balance="{ item }">
              <show-balances-dialog :data="item" @showWallet="walletShow" />
            </template>

            <template v-slot:last_seen="{ item }">
              {{ datetime(item.last_seen, "datetime") }}
            </template>

            <template v-slot:activity="{ item }">
              <v-chip
                small
                :color="activityType(item.activity).color"
                :text-color="activityType(item.activity).textColor"
              >
                <v-icon small start class="ml-1">
                  {{ activityType(item.activity).icon }}
                </v-icon>

                <span class="text-caption">
                  {{ activityType(item.activity).label }}
                </span>
              </v-chip>
            </template>

            <template v-slot:service_id="{ item }">
              {{
                item.service_id != null && item.service_id.length
                  ? item.services.map((s) => s.nameLand).join(", ")
                  : "-"
              }}
            </template>

            <template v-slot:parent_id="{ item }">
              {{ !!item.parent ? item.parent.username : "-" }}
            </template>

            <template v-slot:status="{ item }">
              <div
                :class="
                  item.status === 'active' ? 'badge-success' : 'badge-danger'
                "
                class="badge-pill"
              >
                {{ item.status === "active" ? "فعال" : "غیرفعال" }}
              </div>
            </template>

            <template v-slot:actions="{ item }">
              <user-manage-button :action="actions" :data="item" />
            </template>
          </vue-table>

          <v-divider />
          <contact-sends-pattern
            :items="selectedRows"
            :table-props="tableProps"
          />

          <v-progress-linear
            v-if="loading"
            color="primary"
            height="4"
            indeterminate
          />
        </v-col>
      </v-row>
    </v-card>

    <Information :id="userInfoId" v-model="UserInfoDialog" />

    <custom-popup
      v-model="newUserDialog"
      :cons="{ title: 'ساخت کاربر جدید' }"
      hide-confirm
    >
      <create-user-form
        :loading="loading"
        :errors="formErrors"
        @create-user="createUser"
        @error="(msg) => $toast.error(msg)"
      />
    </custom-popup>

    <custom-popup
      v-model="failedSignUps"
      :cons="{ title: 'ثبت نام ناموفق' }"
      hide-confirm
    >
      <template v-slot:activator></template>
      <v-card class="p-5">
        <data-table
          :columns="columnsFailed"
          :data="failedSignUpsData"
          :debounce-delay="5000"
          :per-page="perPages"
          :translate="translates"
          orderDir="desc"
          @on-table-props-changed="reloadTableSignUpTries"
        />
      </v-card>
    </custom-popup>

    <custom-popup
      v-model="dialog"
      :cons="editCons"
      hide-overlay
      reloadable
      scrollable
    >
      <v-card-text class="position-relative pa-0">
        <v-card>
          <v-card-title
            >انتخاب وضعیت کاربر
            {{ dialogUserInfo.name + " " + dialogUserInfo.lastName }}
          </v-card-title>
          <v-divider />

          <v-card-text>
            <v-row class="mt-3">
              <v-select
                v-model="dialogUserInfo.activity"
                :disabled="statusService"
                :items="types"
                item-text="title"
                item-value="value"
                label="نوع"
                outlined
              />
            </v-row>

            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  نیازها و خواسته ها
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-row
                    v-if="
                      [
                        'active',
                        'attractionAgency',
                        'sellAgency',
                        'passive',
                      ].includes(dialogUserInfo.activity)
                    "
                  >
                    <v-text-field
                      v-model="dialogUserInfo.job"
                      :disabled="statusService"
                      label="شغل"
                      outlined
                      required
                    />
                  </v-row>

                  <v-row
                    v-if="
                      [
                        'active',
                        'attractionAgency',
                        'sellAgency',
                        'passive',
                      ].includes(dialogUserInfo.activity)
                    "
                  >
                    <v-select
                      v-model="dialogUserInfo.service"
                      :error-messages="err !== null ? err.service_name : ''"
                      :items="services"
                      item-text="nameLand"
                      item-value="id"
                      label="انتخاب سرویس"
                      multiple
                      outlined
                      return-object
                    />
                  </v-row>

                  <div
                    v-if="
                      [
                        'active',
                        'attractionAgency',
                        'sellAgency',
                        'passive',
                      ].includes(dialogUserInfo.activity)
                    "
                  >
                    <v-row>
                      <v-text-field
                        v-model="dialogUserInfo.familiarity"
                        class="m-1"
                        label="نحوه آشنایی"
                        outlined
                      />
                    </v-row>
                    <v-row>
                      <v-combobox
                        v-model="dialogUserInfo.asked_gift"
                        :items="gifts"
                        append-icon=""
                        chips
                        clearable
                        label="هدیه درخواستی"
                        outlined
                      >
                        <template
                          v-slot:selection="{
                            attrs,
                            item,
                            select,
                            selected,
                            index,
                          }"
                        >
                          <v-chip
                            :input-value="selected"
                            close
                            label
                            v-bind="attrs"
                            @click="select"
                            @click:close="remove(item)"
                          >
                            <strong>{{ item }}</strong
                            >&nbsp;
                          </v-chip>
                        </template>
                      </v-combobox>

                      <!--                                <v-text-field class="m-1" outlined label="هدیه درخواستی"-->
                      <!--                                              v-model="dialogUserInfo.asked_gift"></v-text-field>-->
                    </v-row>
                    <v-row>
                      <v-text-field
                        v-model="dialogUserInfo.recommendation"
                        class="m-1"
                        label="پیشنهاد کاربر"
                        outlined
                      />
                    </v-row>
                    <v-row>
                      <v-textarea
                        v-model="dialogUserInfo.needs"
                        class="m-1"
                        label="نیازهای کاربر"
                        outlined
                      />
                    </v-row>
                    <v-row>
                      <v-textarea
                        v-model="dialogUserInfo.description"
                        class="m-1"
                        label="توضیحات"
                        outlined
                      />
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="dialogUserInfo.jobHistory"
                        class="m-1"
                        label="سابقه فعالیت در این شغل"
                        outlined
                      />
                    </v-row>

                    <v-row>
                      <v-text-field
                        v-model="dialogUserInfo.post"
                        class="m-1"
                        label="سمت"
                        outlined
                      />
                    </v-row>
                    <v-row>
                      <v-textarea
                        v-model="dialogUserInfo.advertiseUsed"
                        class="m-1"
                        label="چه نوع تبلیغاتی تاحالا استفاده کرده؟"
                        outlined
                      />
                    </v-row>
                    <v-row>
                      <v-textarea
                        v-model="dialogUserInfo.insightAdvertise"
                        class="m-1"
                        label="بیشترین بازخورد را از کدام تبلیغات داشته است؟"
                        outlined
                      />
                    </v-row>

                    <v-row>
                      <v-textarea
                        v-model="dialogUserInfo.previousCompanies"
                        class="m-1"
                        label="چرا با شرکت های قبلی کار نمی کند؟"
                        outlined
                      />
                    </v-row>

                    <date-picker
                      v-model="dialogUserInfo.call_time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DD HH:mm"
                      label="زمان تماس"
                      type="datetime"
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  مشخصات مشتری
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-title v-if="data.phone_number == null"
                    >مشتری نیست!
                  </v-card-title>
                  <v-card-text v-else>
                    <hr class="pb-3" />
                    <v-row>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.first_name"
                          :error-messages="errors.first_name"
                          counter
                          dense
                          label="نام"
                          maxlength="30"
                          outlined
                          @keydown="isStringKey"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.last_name"
                          :error-messages="errors.last_name"
                          counter
                          dense
                          label="نام خانوادگی"
                          maxlength="60"
                          outlined
                          @keydown="isStringKey"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.fathers_name"
                          :error-messages="errors.fathers_name"
                          counter
                          dense
                          label="نام پدر"
                          maxlength="40"
                          outlined
                          @keydown="isStringKey"
                        ></v-text-field>
                      </v-flex>
                    </v-row>
                    <v-row>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.job"
                          :error-messages="errors.job"
                          dense
                          label="شغل"
                          outlined
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.national_code"
                          :error-messages="errors.national_code"
                          :rules="rules.national_code"
                          counter
                          dense
                          label="کدملی"
                          maxlength="10"
                          outlined
                          type="text"
                          @keydown="isNumericKey"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model.number="data.verify_id"
                          :error-messages="errors.verify_id"
                          :rules="rules.isInt"
                          counter
                          dense
                          label="شماره شناسنامه"
                          maxlength="10"
                          outlined
                          @keydown="isNumericKey"
                        ></v-text-field>
                        <!--                  v-model="data.verify_id"-->
                      </v-flex>
                    </v-row>
                    <v-row>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.telephone"
                          :error-messages="errors.telephone"
                          :rules="rules.isInt"
                          counter
                          dense
                          label="شماره تلفن"
                          maxlength="11"
                          outlined
                          @keydown="isNumericKey"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <date-picker
                          v-model="data.birth_day"
                          display-format="jYYYY-jMM-jDD"
                          format="YYYY-MM-DD"
                          label="تاریخ تولد"
                          max="2006-01-01"
                          start="2006-01-01"
                          view="year"
                        />
                      </v-flex>
                      <v-flex class="p-2" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.place_birth"
                          :error-messages="errors.place_birth"
                          dense
                          label="محل تولد"
                          outlined
                        ></v-text-field>
                      </v-flex>
                    </v-row>
                    <v-row>
                      <v-flex class="p-2 d-flex d-inline" lg4 md4 sm12 xl4 xs12>
                        <v-autocomplete
                          v-model="data.province"
                          :error-messages="errors.province"
                          :items="provinces"
                          dense
                          item-text="name"
                          item-value="id"
                          label="استان"
                          outlined
                        >
                          <template slot="item" slot-scope="{ item }"
                            >{{ item.name }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex class="p-2 d-flex d-inline" lg4 md4 sm12 xl4 xs12>
                        <v-text-field
                          v-model="data.phone_number"
                          :error-messages="errors.phone_number"
                          :rules="rules.isInt"
                          counter
                          dense
                          label="شماره موبایل"
                          maxlength="11"
                          outlined
                          @keydown="isNumericKey"
                        />
                        <v-btn
                          v-if="!showOtherPhone"
                          class="mr-2 btn-add-with-text"
                          icon
                          rounded
                          style="top: -9px !important"
                          @click="showOtherPhone = !showOtherPhone"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex
                        v-if="showOtherPhone"
                        class="p-2 d-flex d-inline"
                        lg4
                        md4
                        sm12
                        xl4
                        xs12
                      >
                        <v-text-field
                          v-model="data.other_phone"
                          :error-messages="errors.other_phone"
                          :rules="rules.isInt"
                          counter
                          dense
                          label="شماره دیگر"
                          maxlength="11"
                          outlined
                          @keydown="isNumericKey"
                        ></v-text-field>
                        <v-btn
                          class="mr-2 btn-exit"
                          icon
                          rounded
                          style="top: -9px !important"
                          @click="showOtherPhone = !showOtherPhone"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-row>
                    <v-row>
                      <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                        <v-textarea
                          v-model="data.address"
                          :error-messages="errors.address"
                          dense
                          label="آدرس"
                          outlined
                        ></v-textarea>
                      </v-flex>
                      <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                        <v-textarea
                          v-model="data.description"
                          :error-messages="errors.description"
                          dense
                          label="توضیحات"
                          outlined
                          @keydown="isStringKey"
                        ></v-textarea>
                      </v-flex>
                    </v-row>
                  </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  تکمیل اطلاعات حقیقی یا حقوقی
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-row class="mt-2">
                      <v-chip v-if="userDialogData.type == null"
                        >این کاربر هنوز اطلاعات خود را وارد نکرده است
                      </v-chip>
                      <v-chip v-else-if="userDialogData.type == 'regular'"
                        >کاربر حقیقی
                      </v-chip>
                      <v-chip v-else-if="userDialogData.type == 'legal'"
                        >کاربر حقوقی
                      </v-chip>
                    </v-row>
                    <!--                    <v-checkbox  label="وارد کردن دستی" v-model="manualInfoCheckBox"></v-checkbox>-->

                    <v-row>
                      <v-radio-group v-model="personType" row>
                        <v-radio label="شخص حقیقی" value="regular" />
                        <v-radio label="شخص حقوقی" value="legal" />
                      </v-radio-group>

                      <hr />

                      <div v-if="personType == 'regular'" class="mr-12">
                        <v-row>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="regularData.father_name"
                              dense
                              label="نام پدر"
                              outlined
                              type="text"
                            />
                          </v-flex>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="regularData.nid"
                              dense
                              label="کد ملی"
                              outlined
                              type="text"
                            />
                          </v-flex>
                        </v-row>
                        <v-row>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="regularData.mcode"
                              dense
                              label="شماره شناسنامه"
                              outlined
                              type="text"
                            />
                          </v-flex>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <date-picker
                              v-model="regularData.birthday"
                              display-format="jYYYY-jMM-jDD"
                              format="YYYY-MM-DD"
                              label="تاریخ تولد"
                              max="2006-01-01"
                              start="2006-01-01"
                              view="year"
                            />
                          </v-flex>
                        </v-row>
                        <v-row>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="regularData.born_city"
                              dense
                              label="محل تولد"
                              outlined
                              type="text"
                            />
                          </v-flex>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="regularData.postalCode"
                              dense
                              label="کد پستی"
                              outlined
                              type="text"
                            />
                          </v-flex>
                        </v-row>
                        <v-row>
                          <v-textarea
                            v-model="regularData.address"
                            color="teal"
                            dense
                            label="آدرس کامل"
                            outlined
                            rows="3"
                          />
                        </v-row>
                      </div>

                      <div v-if="personType == 'legal'" class="mr-12">
                        <v-row>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="legalData.name"
                              class="mt-4"
                              dense
                              direction="rtl"
                              label="نام شرکت/فروشگاه"
                              outlined
                              type="text"
                            />
                          </v-flex>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="legalData.registration_number"
                              class="mt-4"
                              dense
                              label="شماره ثبت"
                              outlined
                              type="text"
                            />
                          </v-flex>
                        </v-row>
                        <v-row>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="legalData.economic_code"
                              dense
                              direction="rtl"
                              label="کد اقتصادی"
                              outlined
                              type="text"
                            />
                          </v-flex>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="legalData.organization_identity"
                              dense
                              label="شناسنامه ملی سازمانی"
                              outlined
                              type="text"
                            />
                          </v-flex>
                        </v-row>
                        <v-row>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-select
                              v-model="legalData.type"
                              :items="items"
                              dense
                              item-text="name"
                              item-value="valueName"
                              label=" نوع شرکت"
                              outlined
                            />
                          </v-flex>
                          <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
                            <v-text-field
                              v-model="legalData.activity"
                              dense
                              label="حوزه فعالیت"
                              outlined
                              type="text"
                            />
                          </v-flex>
                        </v-row>
                      </div>
                    </v-row>
                  </v-card-text>

                  <v-card-title v-if="personType !== null">
                    <v-row align-content="center" justify="center">
                      <v-btn
                        :loading="loading"
                        class="px-5 btn-update"
                        width="80%"
                        @click="submitTypeData"
                      >
                        <span class="fa fa-bookmark icon-md ml-1"></span>
                        ذخیره و بروزرسانی
                      </v-btn>
                    </v-row>
                  </v-card-title>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-card-text>

      <template v-slot:action></template>
    </custom-popup>

    <custom-popup
      v-model="messageModal"
      :cons="{ title: 'ارسال پیام به کاربران انتخاب شده' }"
      hide-confirm
    >
      <template v-slot:activator />
      <v-card>
        <v-card-title>
          <span class="text-h5">ارسال پیام</span>
          <v-spacer></v-spacer>
          <v-btn
            class="ml-1 text-danger"
            icon
            rounded
            small
            @click="messageModal = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <hr />
        <v-card-text>
          <br />
          <v-container>
            <v-row>
              <v-flex class="p-2" lg12 md12 sm12 xl12 xs12>
                <v-autocomplete
                  v-model="category_id"
                  :items="messageCategories.data"
                  clearable
                  dense
                  item-text="title"
                  item-value="id"
                  label="انتخاب دسته بندی"
                  outlined
                  @change="getMessageQuery"
                >
                  <template slot="item" slot-scope="{ item, tile }">
                    <div>{{ item.title }}</div>
                  </template>
                  <template slot="append-item">
                    <v-container>
                      <div class="text-center">
                        <v-pagination
                          v-model="page"
                          :length="messageCategories.last_page"
                          circle
                        >
                          {{ messageCategories.last_page }}
                        </v-pagination>
                      </div>
                    </v-container>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex v-if="messages.data" class="p-2" lg12 md12 sm12 xl12 xs12>
                <v-autocomplete
                  v-model="message"
                  :error-messages="formErrors.id"
                  :items="messages.data"
                  clearable
                  dense
                  filled
                  item-text="title"
                  item-value="id"
                  label="عنوان پیام"
                  @click:clear="clearField"
                />
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="btn-cancel" @click="messageModal = false">
            انصراف
          </v-btn>
          <v-btn class="submit-btn" @click="sendSms"> ارسال</v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>

    <custom-popup
      v-model="walletModal"
      :cons="{ title: 'کیف پول کاربر' }"
      hide-confirm
    >
      <v-card :loading="priceLoading">
        <v-chip :loading="priceLoading" class="ma-2" color="primary" label>
          ترمینال:
          {{
            !!userBalances.core ? persian(price(userBalances.core)) : persian(0)
          }}
          ریال
        </v-chip>

        <v-chip
          v-can="'admin_operator_wallet'"
          class="ma-2"
          color="primary"
          label
          >پیامک زنده:
          {{
            !!userBalances.payamak
              ? persian(price(userBalances.payamak))
              : persian(0)
          }}
          ریال
        </v-chip>

        <v-chip
          v-can="'admin_real_estate_wallet'"
          class="ma-2"
          color="primary"
          label
        >
          تازه های دیوار:
          {{
            !!userBalances.statePrice
              ? persian(price(userBalances.statePrice))
              : persian(0)
          }}
          ریال
        </v-chip>
      </v-card>
    </custom-popup>
  </v-container>
</template>

<script>
import userManageButton from "@/view/pages/admin/users/userManageButton";
import Wallet from "./actions/Wallet";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";
import Provinces from "@/Provinces.json";
import Information from "@/view/pages/admin/users/actions/Information";
import Pagination from "../../pickers/pagination";
import showBalancesDialog from "@/view/pages/admin/users/showBalancesDialog.vue";
import Button from "@/view/pages/Button.vue";
import userPhoneButtons from "@/view/pages/admin/users/actions/userPhoneButtons.vue";
import ContactSendsPattern from "@/view/content/contacts/contactSendsPattern.vue";
import CreateUserForm from "./CreateUserForm.vue";

export default {
  components: {
    ContactSendsPattern,
    Pagination,
    Wallet,
    Information,
    userPhoneButtons,
    showBalancesDialog,
    userManageButton,
    CreateUserForm,
  },

  data() {
    return {
      walletModal: false,
      userBalances: {
        core: 0,
        payamak: 0,
        statePrice: 0,
      },
      priceLoading: false,
      packs: [],
      balanceItems: [
        { value: "no_charge", text: "بدون شارژ" },
        { value: "has_charge", text: "دارای شارژ" },
        { value: "max_charge", text: "بیشترین شارژ" },
      ],
      category_id: "",
      rules: {
        national_code: [
          (val) =>
            !val ||
            this.checkNationalCode(this.english(val)) ||
            "کد ملی اشتباه است.",
        ],
        isInt: [(val) => !val || Number(val.toString()) || "فقظ عدد وارد کنید"],
      },
      gifts: [
        "طراحی کارت ویزیت",
        "طراحی لوگو",
        "یک بانک اطلاعاتی",
        "طراحی پاکت نامه",
        "طراحی بنر تبلیغاتی",
        "طراحی ۵ استیکر",
        "یک مقاله ۵۰۰ کلمه ای برای سایت",
        "10لاین شماره همراه",
        " خط اختصاصی 14رقمی ارسال پیامک",
        "ساخت پیج بزینسی اینستاگرام",
      ],
      editCons: {
        title: "ویرایش وضعیت",
        buttons: [{ text: "", type: "submit", handler: this.updateUserInfo }],
      },
      errors: [],
      showOtherPhone: false,
      UserInfoDialog: false,
      userInfoId: null,
      personType: null,
      manualInfoCheckBox: false,
      provinces: [],
      userDialogData: {},
      formErrors: {},
      data: {
        id: null,
        user_id: null,
        send_sms: null,
        created_at: null,
        updated_at: null,
        last_name: null,
        fathers_name: null,
        job: null,
        province: null,
        national_code: null,
        address: null,
        place_birth: null,
        birth_day: null,
        phone_number: null,
        other_phone: null,
        telephone: null,
        description: null,
        deleted_at: null,
      },
      regularData: {
        father_name: null,
        birthday: null,
        born_city: null,
        address: null,
        mcode: null,
        nid: null,
        postalCode: null,
        description: null,
      },
      items: [
        { name: "دولتی", valueName: "governmental" },
        { name: "خصوصی", valueName: "private" },
        { name: "سهامی عام", valueName: "common_stock" },
        { name: "سهامی خاص", valueName: "special_stock" },
      ],
      legalData: {
        name: null,
        registration_number: null,
        economic_code: null,
        organization_identity: null,
        activity: null,
        statute: null,
        company_type: null,
        type: null,
      },
      page: 1,
      messageCategories: [],
      categoryUrl: "message/categories",
      query: {
        page: 1,
        search: "",
        length: 5,
      },
      messageModal: false,
      newUserDialog: false,
      failedSignUps: false,
      failedSignUpsData: [],
      columnsFailed: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          label: "نام",
          name: "name",
          orderable: true,
        },
        {
          label: "نام خانوادگی",
          name: "lastName",
          orderable: true,
        },
        {
          label: "تلفن",
          name: "phone",
          orderable: true,
        },
        {
          label: "تاریخ درخواست",
          name: "created_at",
          transform: (val) => {
            return this.$options.filters.longDate(val.data.created_at);
          },
        },
        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "user_",
            buttons: [
              {
                name: "delete",
                label: "حذف",
                icon: "trash",
                class: "btn-delete",
              },
            ],
          },
        },
      ],
      headers: [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        { value: "id", text: "شناسه", align: "center", sortable: false },
        { value: "name", text: "نام", align: "center", sortable: false },
        {
          value: "lastName",
          text: "نام خانوادگی",
          align: "center",
          sortable: false,
        },
        {
          value: "username",
          text: "نام کاربری",
          align: "center",
          sortable: false,
        },
        { value: "phone", text: "تلفن", align: "center", sortable: false },
        { value: "pack", text: "پنل", align: "center", sortable: false },
        { value: "balance", text: "موجودی", align: "center", sortable: false },
        {
          value: "last_seen",
          text: "اخرین ورود",
          align: "center",
          sortable: false,
        },
        { value: "activity", text: "فعالیت", align: "center", sortable: false },
        { value: "job", text: "شغل", align: "center", sortable: false },
        {
          value: "service_id",
          text: "سرویس جذب شده",
          align: "center",
          sortable: false,
        },
        { value: "parent_id", text: "معرف", align: "center", sortable: false },
        { value: "status", text: "نوع", align: "center", sortable: false },
        { value: "actions", text: "عملیات", align: "center", sortable: false },
      ],
      err: null,
      messages: [],
      message: null,
      selectedRows: [],
      tempService: [],
      statusService: false,
      dialog: false,
      loadingBtn: false,
      loading: false,
      dialogUserInfo: {
        id: null,
        activity: null,
        job: null,
        service: null,
        familiarity: null,
        asked_gift: null,
        recommendation: null,
        needs: null,
        requirements: null,
        description: null,
        call_time: null,
        jobHistory: null,
        advertiseUsed: null,
        insightAdvertise: null,
        previousCompanies: null,
        post: null,
        neededCustomers: null,
        lastName: null,
      },
      job: null,
      services: [],
      service: null,
      type: null,
      types: [
        { title: "فعال", value: "active" },
        { title: "عاملیت جذب", value: "attractionAgency" },
        { title: "عاملیت فروش", value: "sellAgency" },
        { title: "منفعل", value: "passive" },
      ],
      dialogInfo: null,
      isFilter: false,
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tablePropsFailed: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },
      timoutTimer: null,
      userInfo: {},
      tableProps: {
        search: "",
        page: 1,
        length: 10,
        column: "id",
        dir: "desc",
        filters: {
          name: "",
          lastName: "",
          username: "",
          phone: "",
          packId: "",
        },
      },
    };
  },

  async mounted() {
    let local = JSON.parse(localStorage.getItem("core_list"));
    if (local) {
      this.tableProps = local;
    }

    try {
      this.services = await this.getService(); // منتظر دریافت داده‌ها
      console.log(this.services, "services"); // بعد از به‌روزرسانی چاپ کن
    } catch (error) {
      console.error("Failed to fetch services:", error);
      this.$toast.error("خطا در دریافت سرویس‌ها");
    } finally {
    }
    this.getUserInfo();
    this.provinces = Provinces;
    this.getPacks();
    window.Vue.$on("selectAllListCheckBox", (e) => {
      this.selectAll(e.checked);
    });
  },
  computed: {
    disableRemoveFilter() {
      return (
        !!this.tableProps.search ||
        this.tableProps.length > 10 ||
        !!this.tableProps.filters.name ||
        !!this.tableProps.filters.lastName ||
        !!this.tableProps.filters.username ||
        !!this.tableProps.filters.phone
      );
    },
  },

  watch: {
    tableProps: {
      deep: true,
      handler(val) {
        localStorage.setItem("core_list", JSON.stringify(val));
      },
    },

    options(val) {
      if (this.isFilter) {
        this.tablePropsFailed.page = val.page;
        this.tablePropsFailed.length = val.itemsPerPage;
        this.tablePropsFailed.column = val.sortBy[0] ?? "id";
        this.getSignUpTries(this.tablePropsFailed);
      }
    },
    page(val) {
      this.query.page = val;
      this.getMessageCategories(this.categoryUrl, this.query);
    },
    failedSignUps(val) {
      this.getSignUpTries(this.tablePropsFailed);
    },
    
    dialog(val) {
      if (val == false) {
        this.data.id = null;
        this.data.user_id = null;
        this.data.send_sms = null;
        this.data.created_at = null;
        this.data.updated_at = null;
        this.data.first_name = null;
        this.data.last_name = null;
        this.data.fathers_name = null;
        this.data.job = null;
        this.data.province = null;
        this.data.national_code = null;
        this.data.address = null;
        this.data.place_birth = null;
        this.data.birth_day = null;
        this.data.phone_number = null;
        this.data.other_phone = null;
        this.data.telephone = null;
        this.data.description = null;
        this.data.deleted_at = null;
      }
    },
  },

  methods: {
    copyText(text) {
      if (navigator) {
        navigator.clipboard.writeText(text);
      }
      this.copied = true;
      let i = setInterval(() => {
        this.copied = false;
        clearInterval(i);
      }, 1000);
    },
    getPacks() {
      this.requestApiGet("pack?length=10000").then(({ data }) => {
        this.packs = data.data;
      });
    },
    officialTypeColor(title) {
      const colors = {
        unofficial: 'rgb(245, 181, 62)',
        official: 'rgb(103, 254, 103)',
        pending: 'white'
      };

  return colors[title] || 'white';
},
    walletShow({ id }) {
      this.userBalances = {
        core: 0,
        payamak: 0,
        statePrice: 0,
      };
      this.priceLoading = true;
      this.walletModal = true;

      const userWallet = () =>
        new Promise((resolve, reject) => {
          this.requestApiGet("newWallet/userWallet", { userId: id })
            .then(({ data }) => {
              let price =
                data?.data &&
                Object.hasOwn(data.data, "balance") &&
                typeof data.data.balance !== "object"
                  ? data.data.balance
                  : data.data.balance.$numberDecimal;

              resolve(price);
            })
            .catch(({ res }) => {
              reject("خطا");
              this.$toast.error("خطا در دریافت کیف پول ترمینال");
            });
        });

      const payamakWallet = () =>
        new Promise((resolve, reject) => {
          this.requestApiPostPayamak("wallet/admin/balance", { user_id: id })
            .then(({ data }) => {
              resolve(data.data.balance);
            })
            .catch((error) => {
              reject("خطا");
            });
        });

      const stateWallet = () =>
        new Promise((resolve, reject) => {
          this.requestApiPostState("user/wallet/admin/balance", { user_id: id })
            .then(({ data }) => {
              resolve(data.data.balance);
            })
            .catch((error) => {
              reject("خطا");
            });
        });

      userWallet()
        .then((price) => {
          this.userBalances.core = price;
          payamakWallet().then((price) => {
            this.userBalances.payamak = price;
            stateWallet().then((price) => {
              this.userBalances.statePrice = price;
            });
          });
        })
        .finally(() => (this.priceLoading = false));
    },
    reloadTableSignUpTries(tableProps) {
      this.getSignUpTries(tableProps);
    },
    submitTypeData() {
      this.$modal.showLoading();
      this.requestApiPost("admin/user/updateUserInfo", {
        manualInfo: this.manualInfoCheckBox,
        person_type: this.personType,
        regularData: this.regularData,
        legalData: this.legalData,
        user_id: this.dialogUserInfo.id,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.messageModal = false;
          this.dialog = false;
          this.getUserInfo();
          this.$toast.success("اطلاعات با موفقیت به روزرسانی شد");
        })
        .catch(({ response }) => {
          this.formErrors = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    createUser(newUser) {
      this.$modal.showLoading();
      this.requestApiPost("admin/user/create", {
        name: newUser.name,
        lastName: newUser.lastName,
        phone: newUser.phone,
        nid: newUser.nid,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.newUserDialog = false;
          this.getUserInfo();
          this.$toast.success("کاربر جدید با موفقیت ایجاد شد");
        })
        .catch(({ response }) => {
          this.formErrors = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    clearField(all = false) {
      if (all) {
        this.tableProps = {
          search: "",
          page: 1,
          length: 10,
          column: "id",
          dir: "desc",
          filters: {
            name: "",
            lastName: "",
            username: "",
            phone: "",
            packId: "",
          },
        };
      }
      this.$nextTick(() => {
        this.onPagination();
      });
    },
    remove(item) {
      this.dialogUserInfo.asked_gift = "";
    },
    getMessageQuery() {
      if (this.category_id !== null) return this.getMessage(this.category_id);
      return (this.messages = []);
    },
    getMessageCategories(url = this.categoryUrl, query = this.query) {
      if (query.search === null) this.$modal.showLoading();
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.messageCategories = data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    getSignUpTries(query = this.tablePropsFailed) {
      this.$modal.showLoading();

      this.requestApiGet("signUpTries", query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.length = data.data.total;
          this.failedSignUpsData = data.data;
          this.isFilter = true;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    getMessage(query) {
      this.requestApiGet(`user/messages/${query}`)
        .then((data) => {
          this.$modal.hideLoading();
          this.messages = data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    async showSms() {
      if (this.selectedRows.length === 0)
        return this.$toast.error("هیچ موردی انتخاب نشده است.");
      this.$modal.showLoading();
      await this.getMessageCategories();
      this.messageModal = true;
    },
    sendSms() {
      this.$modal.showLoading();
      this.requestApiPost("user/send-message", {
        id: this.message,
        user_id: this.selectedRows,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.messageModal = false;
          this.$toast.success("پیام برای مشتریان ارسال شد.");
        })
        .catch(({ response }) => {
          this.formErrors = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    getServices() {
      this.requestApiGet("getServices").then((response) => {
        this.services = response.data.services;
      });
    },
    change(data, checked) {
      if (checked) {
        this.selectedRows.push(data.id);
      } else {
        let index = this.selectedRows.indexOf(data.id);
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1, this.selectedRows.length),
        ];
      }
      window.document.querySelector("#select_all").checked =
        this.selectedRows.length == this.userInfo.data.length;
    },
    filterOnlyCapsText(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      );
    },
    getUserInfo(params = this.tableProps) {
      this.loading = true;

      this.requestApiGet("admin/users", params)
        .then((response) => {
          this.userInfo = response.data;
        })
        .finally(() => (this.loading = false));
    },
    hasFilter(f) {
      return (
        !!f.filters.name ||
        !!f.filters.lastName ||
        !!f.filters.username ||
        !!f.filters.phone ||
        !!f.search
      );
    },
    onPagination(e) {
      if (!e?.page) e = { page: 1 };

      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getUserInfo(props);
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1;
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.$router.push({ name: "admin.user.edit", params: { id: data.id } });
    },
    information(data) {
      this.userInfoId = data.id;
      this.UserInfoDialog = true;
    },
    userActivity(data) {
      this.err = null;
      this.userDialogData = data;
      this.personType = data.type;

      if (data.personType !== null) {
        if (data.bussiness !== null) {
          this.legalData = data.bussiness;
          this.regularData.created_at = null;
          this.regularData.updated_at = null;
        } else {
          this.legalData.name = null;
          this.legalData.registration_number = null;
          this.legalData.economic_code = null;
          this.legalData.organization_identity = null;
          this.legalData.activity = null;
          this.legalData.statute = null;
          this.legalData.company_type = null;
          this.legalData.type = null;
        }

        if (data.user_info !== null) {
          this.regularData = data.user_info;
          this.regularData.created_at = null;
          this.regularData.updated_at = null;
        } else {
          this.regularData.father_name = null;
          this.regularData.birthday = null;
          this.regularData.born_city = null;
          this.regularData.address = null;
          this.regularData.mcode = null;
          this.regularData.nid = null;
          this.regularData.postalCode = null;
          this.regularData.description = null;
        }
      }

      if (data.customer !== null) {
        this.data = data.customer;
      } else {
        this.data.id = null;
        this.data.user_id = null;
        this.data.send_sms = null;
        this.data.created_at = null;
        this.data.updated_at = null;
        this.data.first_name = null;
        this.data.last_name = null;
        this.data.fathers_name = null;
        this.data.job = null;
        this.data.province = null;
        this.data.national_code = null;
        this.data.address = null;
        this.data.place_birth = null;
        this.data.birth_day = null;
        this.data.phone_number = null;
        this.data.other_phone = null;
        this.data.telephone = null;
        this.data.description = null;
        this.data.deleted_at = null;
      }

      if (this.can("allStatus_edit")) {
        this.dialogUserInfo.id = data.id;
        this.dialogUserInfo.activity = data.activity;
        this.dialogUserInfo.job = data.job;
        this.dialogUserInfo.service = data.services;
        this.tempService = data.service_id;
        this.dialogUserInfo.name = data.name;
        this.dialogUserInfo.lastName = data.lastName;
        this.dialogUserInfo.familiarity = data.familiarity;
        this.dialogUserInfo.asked_gift = data.asked_gift;
        this.dialogUserInfo.recommendation = data.recommendation;
        this.dialogUserInfo.needs = data.needs;
        this.dialogUserInfo.requirements = data.requirements;
        this.dialogUserInfo.description = data.description;
        this.dialogUserInfo.call_time = data.call_time;
        this.dialogUserInfo.jobHistory = data.jobHistory;
        this.dialogUserInfo.advertiseUsed = data.advertiseUsed;
        this.dialogUserInfo.insightAdvertise = data.insightAdvertise;
        this.dialogUserInfo.previousCompanies = data.previousCompanies;
        this.dialogUserInfo.post = data.post;
        this.dialogUserInfo.neededCustomers = data.neededCustomers;
        this.dialog = true;
        return;
      } else if (data.activity !== null) {
        if (this.can("userEdited_edit")) {
          this.dialogUserInfo.id = data.id;
          this.dialogUserInfo.activity = data.activity;
          this.dialogUserInfo.job = data.job;
          this.dialogUserInfo.service = data.services;
          this.tempService = data.service_id;
          this.dialogUserInfo.name = data.name;
          this.dialogUserInfo.lastName = data.lastName;
          this.dialogUserInfo.familiarity = data.familiarity;
          this.dialogUserInfo.asked_gift = data.asked_gift;
          this.dialogUserInfo.recommendation = data.recommendation;
          this.dialogUserInfo.needs = data.needs;
          this.dialogUserInfo.requirements = data.requirements;
          this.dialogUserInfo.description = data.description;
          this.dialogUserInfo.call_time = data.call_time;
          this.dialogUserInfo.jobHistory = data.jobHistory;
          this.dialogUserInfo.advertiseUsed = data.advertiseUsed;
          this.dialogUserInfo.insightAdvertise = data.insightAdvertise;
          this.dialogUserInfo.previousCompanies = data.previousCompanies;
          this.dialogUserInfo.post = data.post;
          this.dialogUserInfo.neededCustomers = data.neededCustomers;
          this.dialog = true;
          return;
        } else if (this.can("serviceStatus_edit")) {
          this.statusService = true;
          this.dialogUserInfo.id = data.id;
          this.dialogUserInfo.activity = data.activity;
          this.dialogUserInfo.job = data.job;
          this.dialogUserInfo.service = data.services;
          this.tempService = data.service_id;
          this.dialogUserInfo.name = data.name;
          this.dialogUserInfo.lastName = data.lastName;
          this.dialogUserInfo.familiarity = data.familiarity;
          this.dialogUserInfo.asked_gift = data.asked_gift;
          this.dialogUserInfo.recommendation = data.recommendation;
          this.dialogUserInfo.needs = data.needs;
          this.dialogUserInfo.requirements = data.requirements;
          this.dialogUserInfo.description = data.description;
          this.dialogUserInfo.call_time = data.call_time;
          this.dialog = true;
          return;
        } else {
          this.$toast.warning(
            "شما دسترسی به ویرایش اطلاعات ثبت شده را ندارید!",
          );    
        }
      } else {
        if (this.can("userUnedited_edit")) {
          this.dialogUserInfo.name = data.name;
          this.dialogUserInfo.lastName = data.lastName;
          this.dialog = true;
          return;
        } else {
          this.$toast.warning("شما دسترسی به ثبت اطلاعات کاربر را ندارید!");
        }
      }
    },
    userWallet(data) {
      this.$router.push({ name: "admin.user.edit", params: { id: data.id } });
    },
    updateUserInfo() {
      this.loadingBtn = true;

      if (this.dialogUserInfo.service) {
        this.requestApiPost(`admin/user/changeInfo`, {
          user_id: this.dialogUserInfo.id,
          activity: this.dialogUserInfo.activity,
          familiarity: this.dialogUserInfo.familiarity,
          asked_gift: this.dialogUserInfo.asked_gift,
          recommendation: this.dialogUserInfo.recommendation,
          needs: this.dialogUserInfo.needs,
          requirements: this.dialogUserInfo.requirements,
          description: this.dialogUserInfo.description,
          call_time: this.dialogUserInfo.call_time,
          jobHistory: this.dialogUserInfo.jobHistory,
          advertiseUsed: this.dialogUserInfo.advertiseUsed,
          insightAdvertise: this.dialogUserInfo.insightAdvertise,
          previousCompanies: this.dialogUserInfo.previousCompanies,
          post: this.dialogUserInfo.post,
          neededCustomers: this.dialogUserInfo.neededCustomers,
          job: this.dialogUserInfo.job,
          customerData: this.data,
          service_name: this.dialogUserInfo.service.map((item) => item.id),
        })
          .then(({ data }) => {
            this.loadingBtn = false;
            this.dialog = false;
            this.getUserInfo();
            this.$toast.success("وضعیت کاربر با موفقیت ویرایش شد.");
          })
          .catch(({ response }) => {
            this.loadingBtn = false;
            this.err = response.data.errors;
          });
      } else {
        this.requestApiPost(`admin/user/changeInfo`, {
          user_id: this.dialogUserInfo.id,
          activity: this.dialogUserInfo.activity,
          job: this.dialogUserInfo.job,
        }).then(({ data }) => {
          this.loadingBtn = false;
          this.dialog = false;
          this.getUserInfo();
          this.$toast.success("وضعیت کاربر با موفقیت ویرایش شد.");
        });
      }
    },
    wallett(data) {
      this.$router.push({
        name: "admin.users.wallet",
        params: { id: data.id},
        query: { official_type: data.official_type }, 
      });
    },
    activityType(data) {
      switch (data) {
        case "active":
          return {
            label: "فعال",
            color: "green lighten-3",
            icon: "mdi-check-circle",
            textColor: "green darken-4",
          };
        case "attractionAgency":
          return {
            label: "عاملیت جذب",
            color: "orange lighten-3",
            icon: "mdi-magnet",
            textColor: "orange darken-4",
          };
        case "sellAgency":
          return {
            label: "عاملیت فروش",
            color: "blue lighten-3",
            icon: "mdi-storefront",
            textColor: "blue darken-4",
          };
        case "passive":
          return {
            label: "منفعل",
            color: "red lighten-3",
            icon: "mdi-minus-circle",
            textColor: "red darken-4",
          };
        default:
          return {
            label: "ثبت نشده",
            color: "yellow lighten-3",
            icon: "mdi-help-circle",
            textColor: "brown darken-4",
          };
      }
    },
    history(data) {
      this.$router.push({
        name: "admin.users.history",
        params: { phone: data.phone },
      });
    },
    serviceType(data) {
      let firstServiceId = data[1];
      if (firstServiceId === "1") {
        return "کورلند";
      } else if (firstServiceId === "2") {
        return "پیامک لند";
      } else if (firstServiceId === "3") {
        return "کیوآرلند";
      } else if (firstServiceId === "4") {
        return "ربات لند";
      } else if (firstServiceId === "5") {
        return "بیلبورد";
      } else if (firstServiceId === "6") {
        return "تبلیغ نگار";
      } else {
        return "ثبت نشده";
      }
    },
    delete(data) {
      this.$can();
      this.$swal({
        text: "آیا از حذف این مورد اطمینان دارید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
        reverseButtons: true,
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary",
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestApiDelete(`signUptries/${data.id}`).then((response) => {
            this.onPagination();
            this.$toast.success("با موفقیت حذف شد");
          });
        }
      });
    },
    checkout(data) {
      this.$modal.showLoading();

      this.getUserTokenWithId(data.id)
        .then((token) => {
          try {
            loginRollback.addLogin(this.getUser()?.name, jwtService.getToken());
            jwtService.saveToken(token);
            window.history.pushState(
              "dashboard",
              "dashboard",
              this.$router.resolve({ path: "/dashboard" }).href,
            );
            window.location.reload();
          } catch (e) {
            console.log(e);
          }
        })
        .catch((e) => {
          this.$toast.error("error");
        })
        .finally(() => {
          this.$modal.hideLoading();
        });
    },
  },
};

$("#select_all").click(function () {
  $(".checkBox").prop("checked", $(this).prop("checked"));
});
</script>

<style scoped>
.fixed-content {
  min-height: 100%;
  position: fixed;
  overflow-y: scroll;
  overflow-x: hidden;
 
}
</style>
